export const getCampaign = (state) => {
  return (stateSlice) => {
    if (stateSlice) {
      const slice = state[stateSlice];

      if (!slice) {
        throw new Error(`Unable to find ${stateSlice} in state.`);
      }

      return slice["parentCampaign"];
    }

    return state["parentCampaign"];
  };
};

export const getCustomFields = (state) => {
  return (stateSlice) => {
    const customFields = getCampaign(state)(stateSlice).get("custom_fields");

    return customFields || [];
  };
};
